import styled from 'styled-components';
import { createTripleButton } from '../../button/triple-button/triple-button';
import { Color } from '../../color/color';
import { FontSize } from '../../font/font-size';
import { FontWeight } from '../../font/font-weight';

const Container = styled.div.withConfig({
  componentId: 'modal_container',
  displayName: 'Modal.Container',
})`
  pointer-events: auto;
  border-radius: 10px;
  border: 1px solid ${Color.black5};
  background-color: ${Color.black2};
`;

const Header = styled.div.withConfig({
  componentId: 'modal_header',
  displayName: 'Modal.Header',
})`
  padding: 10px;
`;

const Title = styled.div.withConfig({
  componentId: 'modal_title',
  displayName: 'Modal.Title',
})`
  font-size: ${FontSize.l3};
  font-weight: ${FontWeight.l1};
  color: ${Color.white3};
`;

const Text = styled.div.withConfig({
  componentId: 'modal_text',
  displayName: 'Modal.Text',
})`
  font-size: ${FontSize.l1};
  font-weight: ${FontWeight.l1};
  color: ${Color.white5};
`;

const Text2 = styled.div.withConfig({
  componentId: 'modal_text',
  displayName: 'Modal.Text',
})`
  font-size: ${FontSize.l1};
  font-weight: ${FontWeight.base};
  color: ${Color.white6};
`;

const Content = styled.div.withConfig({
  componentId: 'modal_content',
  displayName: 'Modal.Content',
})`
  padding: 10px;
`;

const ContentTitle = styled.div.withConfig({
  componentId: 'modal_content_title',
  displayName: 'Modal.ContentTitle',
})`
  font-size: ${FontSize.l1};
  font-weight: ${FontWeight.l1};
  color: ${Color.white3};
`;

const Footer = styled.div.withConfig({
  componentId: 'modal_footer',
  displayName: 'Modal.Footer',
})`
  padding: 10px;
`;

const FooterButton = createTripleButton({
  sizing: {
    shrinkX: '10px',
    shrinkY: '10px',
    borderRadius: '4px',
    gap: '8px',
  },
  background: {
    color: {
      base: {
        normal: 'rgba(255, 255, 255, 0.0)',
        hover: 'rgba(255, 255, 255, 0.1)',
      },
      selected: {
        normal: 'rgba(255, 255, 255, 0.1)',
        hover: 'rgba(255, 255, 255, 0.2)',
      },
    },
  },
  icon: {
    size: '16px',
    color: {
      base: {
        normal: 'rgba(255, 255, 255, 0.2)',
        hover: 'rgba(255, 255, 255, 0.4)',
      },
      selected: {
        normal: 'rgba(255, 255, 255, 0.4)',
        hover: 'rgba(255, 255, 255, 0.6)',
      },
    },
  },
  text: {
    size: FontSize.l1,
    weight: FontWeight.l1,
    color: {
      base: {
        normal: 'rgba(255, 255, 255, 0.7)',
        hover: 'rgba(255, 255, 255, 0.9)',
      },
      selected: {
        normal: 'rgba(255, 255, 255, 0.9)',
        hover: 'rgba(255, 255, 255, 1)',
      },
    },
  },
  config: {
    componentId: 'side-bar-item',
    displayName: 'SideBarItem',
  },
});

const Input = styled.input.withConfig({
  componentId: 'modal_input',
  displayName: 'Modal.Input',
})`
  width: 100%;
  height: 36px;

  border: 1px solid ${Color.black5};
  border-radius: 4px;
  background-color: ${Color.black2};

  padding: 10px;

  font-size: ${FontSize.l1};
  color: ${Color.white3};
`;

export const ModalStyle = {
  Container,
  Header,
  Title,
  Text,
  Text2,
  Content,
  ContentTitle,
  Footer,
  FooterButton,
  Input,
};
